import {GroupBase} from 'react-select';
import cnBind from 'classnames/bind';
import {useStoreon} from 'storeon/react';
import {FormikValues} from 'formik';
import {toast} from 'react-toastify';
import dayjs from 'dayjs';
import { api } from '@/api';
import { orderApiReq, taskApiReq, userApiReq } from '@/api/interfaces/requests';
import { ICreateOrder, IDateTimeOrdersState, ITaskState, IUser, IUserDepositList, TCreateByStaff, TLabelAndValue, TReturnCertificate, TReturnDeposit, TReturnMoneyDeposit, TTariffRate, TUserDeposit } from '@/types';
import { tariffApiRes } from '@/api/interfaces/responses';
import { objectKeys } from '@/utils';
import { IGetActualTariffRes } from '@/api/domains/TariffApi/interfaces/response';
import { IFilters } from '@/apps/Tasks/interfaces';
import {
  CREATE_USER_RES_TYPE,
    DEPOSIT_PAYMENT_TITLE,
    NAME_STATUS_API_ORDER,
    PAY_LINK_TTL,
    PAY_LINK_TTL_EMPTY,
    saleSourceOptions,
    TRANSLATE_LABELS_ERR,
    TYPE_USER_SPORTSMAN,
    TYPES_STATUS
} from '../consts';
import {ARR_TYPE, NOTIFICATION_TYPE, ORDERS, TYPES_DEPOSITS} from '../../../const';
import styles from '../../../components/SocketLayoutCall/styles/index.module.scss';
import {IInitialValues} from '../components/ModalUser/types';
import {TubeIcon, WaveIcon} from '../../../assets';
import {getArrParticipants} from '../components/ModalOrder/helpers';
import { ICreateOrderProps, IUpdateOrder} from '../components/ModalOrder/interfaces';
import {TYPE_STOCK} from '../components/ModalOrder/const';
import { ICreatePaymentHelper, ICreateResponseUser, IRangeOptions } from './interfaces';
import { ITariffItem } from '../components/DropdownListTariff/interfaces';

const cn = cnBind.bind(styles);

export function rangeOptions(data: TTariffRate[] | null, flag: boolean, type: number) {
    let options: IRangeOptions[] = [];
    data?.filter((item) => item.is_child === flag).forEach((rate) => {
        options.push({
            value: rate.minutes,
            label: `${type === ORDERS.PIPE ? rate.minutes : rate.count_people} ${type === ORDERS.PIPE ? 'мин.' : 'чел.'}`,
            ...rate
        });
    });
    return options;
}

export function rangeMultiOrdersOptions(data: number[], type: number) {
    let options: (TLabelAndValue | GroupBase<TLabelAndValue>)[] = [];
    for (let i = 0; i < data.length; i += 1) {
        options.push({
            value: data[i],
            label: `${data[i]} ${type === ORDERS.PIPE ? 'мин.' : 'чел.'}`,
        });
    }
    return options;
}

export function createDefaultValues(data: Record<string, any> | null | undefined, selectedUser?: Record<string, any>) {
    return {
        customer: data && {
            value: data.customer.id,
            label: `${data.customer.first_name || ''} ${data.customer.last_name || ''}`, ...data.customer
        } || selectedUser?.label && ({...selectedUser}),
        participants: data && data.participants.map((item: Record<string, any>) => {
            return {
                value: item.id,
                label: `${item.first_name || ''} ${item.last_name || ''}`,
                ...item
            };
        }) || selectedUser?.value && [{...selectedUser}] || [],
        minutes: {value: 0, label: '0 мин.'},
        count_party: data ? {
            value: data.tariff_rate.count_people,
            label: String(data.tariff_rate.count_people)
        } : {value: 0, label: '0'},
        price_paid: data ? data.price_paid : '0.00',
        source: data ? saleSourceOptions[data.source] : undefined,
        tariff: data ? {value: data.tariff.id, label: data.tariff.title, tariff_rates: [], ...data.tariff}
            :
            {value: null, label: null, tariff_rates: [], is_for_sportsman: false},
        base_price:  data ? data.base_price : '0.00',
        price: data ? data.price : '0.00',
        comment: data ? data.comment : '',
        tariff_rate: data ? {
            price: 0,
            strikeout_price: null,
            count_people: data.count_party,
            minutes: data.session_minutes,
            id: data.tariff_rate.id
        } : {
            price: 0, strikeout_price: null, count_people: 0, minutes: 0, id: null
        }, // TODO Поправить
        is_pay_here: data ? data.is_pay_here : true,
        is_arrived: data ? data.is_arrived : false,
        session_minutes: data ? data.fly_session_minutes : 2.5,
        discount: false,
        promo_code: data ? data.promo_code : null,
        status: data ? data.status : null,
        number: data ? data.number : null,
        id: data ? data.id as number : null,
        multiRates: [],
        tariff_rates: [],
        tariff_rate_multi: null,
        is_children: data ? data.is_children : false,
        start_at: data ? data.start_at : null,
        sessionTimeoutSecs: data ? convertTimeToIntegerMinutes(data.tariff.duration_check) : 0,
        is_automatic_stock: data ? data.is_automatic_stock : true,
        price_stock: data ? data.price_stock : '0.00',
        stock: data ? data.stock : undefined,
        payment_url: data && data.pay_order.orders.length > 0 ? data.pay_order.orders[0].payment_url : '',
        payment_confirmation_link: data ? data.payment_confirmation_link : '',
        // eslint-disable-next-line no-nested-ternary
        manual_stock: data && data.stock && TYPE_STOCK.MANUAL === data.stock.type ? {
            value: data.stock.id,
            label: data.stock.title
        } : null,
        pay_order: data ? data.pay_order : null,
        stock_name: (data && data.stock) ? data.stock.title : null,
        side: data ? data.side : null,
        user_type_slug: data ? data.user_type_slug : null,
        author: data ? data.author : null,
        created_at: data ? data.created_at : null,
        is_sport: data ? data.tariff.is_sport : false,
    };
}

/**
 * TODO Оттипизировать values (FormikValues) для createOrder
 */
export const generateArrOrders = (values: FormikValues, side: number, typeOrder :number, date?: string | null): ICreateOrder => {
    return {
        customer: {
          id: values.customer?.value
        },
        tariff: {
          id: values.tariff.value,
          title: values.tariff.label,
          is_child: values.tariff_rate.is_child
        },
        participants: values.participants.map((item: Record<string, any>) => {
            return {
                id: item.value
            };
        }),
        source: values.source ? values.source.value : undefined,
        price: values.base_price,
        count_party: values.tariff_rate.count_people,
        fly_session_minutes: values.session_minutes === 0 ? undefined : (values.customer[TYPE_USER_SPORTSMAN[typeOrder]].is_sport || values.isSportsmanOrder) ? values.session_minutes : undefined,
        comment: values.comment,
        is_pay_here: values.is_pay_here,
        is_automatic_stock: values.is_automatic_stock,
        is_arrived: values.is_arrived,
        is_children: values.is_children,
        stock: values.stock,
        promo_code: values.promo_code,
        tariff_rate: values.tariff_rate.id, // TODO Поправить
        start_at: dayjs(date, 'YYYY.MM.DD HH:mm').subtract(3,'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),

    };
};

// Обрабатываем json с ошибками приходящий с бека
// eslint-disable-next-line consistent-return
export const showErrMessage = (data: Record<string, any>) => {
    try {
        if (data.orders) {
            // eslint-disable-next-line consistent-return
            return Object.entries(data.orders[0]).forEach((item: Record<string, any>) => {
                if (Object.entries(item[1]).length >= 1) {
                    Object.entries(item[1]).forEach((element: Record<string, any>) => {
                        if (element[0] !== '0') {
                            toast.error(`${TRANSLATE_LABELS_ERR[item[0]][element[0]]} ${element[1]}`);
                        } else {
                            toast.error(`${TRANSLATE_LABELS_ERR[item[0]]} ${element[1]}`);
                        }
                    });
                } else {
                    return toast.error(`${TRANSLATE_LABELS_ERR[item[0]]} ${item[1][0]}`);
                }
            });
        }
        if (!data.orders) {
            Object.entries(data).forEach((item: Record<string, any>) => {
                return toast.error(`${TRANSLATE_LABELS_ERR[item[0]]} ${item[1]}`);
            });
        }
    } catch (e) {
        console.log(e);
    }
};

export const showErrMessageUpdateOrder = (data: Record<string, any>) => {
    try {
        Object.entries(data).forEach((item: Record<string, any>) => {
            toast.error(`${TRANSLATE_LABELS_ERR[item[0]]} ${item[1]}`);
        });
    } catch (e) {
        toast.error(NAME_STATUS_API_ORDER.UPDATE.TRANSFER.ERROR);
    }
    // return Object.entries(data.orders[0]).forEach((item: Record<string, any>) => {
    //   if (Object.entries(item[1]).length >= 1) {
    //     Object.entries(item[1]).forEach((element: Record<string, any>) => {
    //       if (element[0] !== '0') {
    //         toast.error(`${TRANSLATE_LABELS_ERR[item[0]][element[0]]} ${element[1]}`);
    //       } else {
    //         toast.error(`${TRANSLATE_LABELS_ERR[item[0]]} ${element[1]}`);
    //       }
    //     })
    //   } else {
    //     toast.error(`${TRANSLATE_LABELS_ERR[item[0]]} ${item[1][0]}`);
    //   }
    // })
};

export const showErrMessageCreateUser = (data: Record<string, any>) => {
    try {
        Object.entries(data).forEach((item: Record<string, any>) => {
            if (item[1] === 'phone') {
                toast.error(item[1]);
            } else {
                toast.error(item[1][0]);
            }
        });
    } catch (e) {
        toast.error(NAME_STATUS_API_ORDER.CREATE.USER.ERROR);
    }
};
export const countCheckedOrders = (data: any) => {
    let count: number = 0;
    if (data.length > 1) {
        data.map((item: any) => item[1].orders.forEach((order: Record<string, any>) => {
            if (order.checked && order.id) {
                count += 1;
            }
        }));
    }
    return count;
};

export const checkPrice = (strikeout_price: string, price: string): number => {
    if (Math.trunc(Number(strikeout_price)) !== 0 && Math.trunc(Number(price)) > Math.trunc(Number(strikeout_price))) {
        return Math.trunc(Number(strikeout_price));
    }
    return Math.trunc(Number(price));
};

export const createUser = (data: TCreateByStaff) => {
    if(data?.phone?.startsWith('++')) {
        data.phone = data?.phone?.replace('++', '+');
    }
    const response = api.user.createUser( data );
    return toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.CREATE.USER.PENDING,
            // success: NAME_STATUS_API_ORDER.CREATE.USER.SUCCESS,
            error: {
                render(res: Record<string, any>) {
                    const {data, status} = res.data.response;
                    if (status === 500 || status === 501 || status === 502 || status === 503) {
                        return NAME_STATUS_API_ORDER.CREATE.USER.ERROR_500 + status;
                    }
                    if (data && status !== 500 || status !== 501 || status !== 502 || status !== 503) {
                        showErrMessageCreateUser(data);
                    }
                    return NAME_STATUS_API_ORDER.CREATE.USER.ERROR;
                }
            }
        });
};

export const updateUser = (id: number, data: userApiReq.IUpdateUserReq) => {
    const response = api.user.updateUser(id, { ...data }
    );
    return toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.UPDATE.USER.PENDING,
            error: {
                render(res: Record<string, any>) {
                    const {status} = res.data.response;
                    switch(status){
                        case 500:
                        case 501:
                        case 502:
                        case 503:
                            return NAME_STATUS_API_ORDER.UPDATE.USER.ERROR_500 + status;
                        case 409:
                            return Object.values(res.data.response.data)[0]
                        default:
                            return NAME_STATUS_API_ORDER.UPDATE.USER.ERROR;
                        }
                    }
                }
            });
        };

export const createTask = (data: taskApiReq.ICreateTaskReq | FormData) => {
    const response = api.task.createTask(data);
    return toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.CREATE.TASK.PENDING,
            error: {
                render(res: Record<string, any>) {
                    const {data, status} = res.data.response;
                    if (status === 500 || status === 501 || status === 502 || status === 503) {
                        return NAME_STATUS_API_ORDER.CREATE.TASK.ERROR_500 + status;
                    }
                    if (data && status !== 500 || status !== 501 || status !== 502 || status !== 503) {
                        showErrMessageCreateUser(data);
                    }
                    return NAME_STATUS_API_ORDER.CREATE.TASK.ERROR;
                }
            }
        });
};

export const useOrder = () => {
    const {dispatch} = useStoreon();

    const deleteOrder = (id: number, closeModal: () => void) => {
        const response = api.order.updateOrders(id, {
            status: 1
        });
        return toast.promise(
            response,
            {
                pending: NAME_STATUS_API_ORDER.DELETE.PENDING,
                // success: NAME_STATUS_API_ORDER.DELETE.SUCCESS,
                error: {
                    render(res: Record<string, any>) {
                        const {data, status} = res.data.response;
                        if (status === 500 || status === 501 || status === 502 || status === 503) {
                            return NAME_STATUS_API_ORDER.CREATE.USER.ERROR_500 + status;
                        }
                        if (data && status !== 500 || status !== 501 || status !== 502 || status !== 503) {
                            showErrMessageCreateUser(data);
                        }
                        return NAME_STATUS_API_ORDER.DELETE.ERROR
                    }
                }
            }).then(() => {
            dispatch('orders/get');
            closeModal();
        });
    };

    const closeOrder = (id: number, closeModal: () => void) => {
        const response = api.order.updateOrders(id, {status: TYPES_STATUS.CLOSE});
        return toast.promise(
            response.then(() => {
                // toast.success(NAME_STATUS_API_ORDER.UPDATE.CLOSE.SUCCESS)
                closeModal();
            }, err => {
                toast.error(err.response.data.non_field_errors[0])
            }),
            {
                pending: NAME_STATUS_API_ORDER.UPDATE.CLOSE.PENDING
            }).then(() => {
            dispatch('orders/get');
        });
    };

    const createOrder = ({orders, closeModal , flagMultiOrders, setStatusLoad, pay=false} :ICreateOrderProps) => {
        setStatusLoad(true)

        const response = api.order.createOrders({
            orders
        });
        toast.promise(
            response,
            {
                pending: flagMultiOrders ? NAME_STATUS_API_ORDER.CREATE.ORDERS.PENDING : NAME_STATUS_API_ORDER.CREATE.ORDER.PENDING,
                // success: flagMultiOrders ? NAME_STATUS_API_ORDER.CREATE.ORDERS.SUCCESS : NAME_STATUS_API_ORDER.CREATE.ORDER.SUCCESS,
                error: {
                    render(res: Record<string, any>) {
                        setStatusLoad(false);
                        try {

                            const {data, status} = res.data.response;
                            if (status === 500 || status === 502 || status === 503) {
                                toast.error(flagMultiOrders ? NAME_STATUS_API_ORDER.CREATE.ORDERS.ERROR_500 : NAME_STATUS_API_ORDER.CREATE.ORDER.ERROR_500);
                            }
                                showErrMessage(data);
                        } catch (e) {
                            console.error(e);
                        }
                        return flagMultiOrders ? NAME_STATUS_API_ORDER.CREATE.ORDERS.ERROR : NAME_STATUS_API_ORDER.CREATE.ORDER.ERROR;
                    }
                }
            }).then(() => {
            if (!pay) dispatch('orders/get');
            setStatusLoad(false);
            if (closeModal) closeModal();
        });
        return response;
    };

    const updateOrder = async ({switcherSpinner, closeModal, id, data, flagTransfer}: IUpdateOrder) => {
        if (switcherSpinner) switcherSpinner(true);
        const response = api.order.updateOrders(id, data);
        toast.promise(
            response,
            {
                pending: flagTransfer ? NAME_STATUS_API_ORDER.UPDATE.TRANSFER.PENDING : NAME_STATUS_API_ORDER.UPDATE.PENDING,
                // success: flagTransfer ? NAME_STATUS_API_ORDER.UPDATE.TRANSFER.SUCCESS : NAME_STATUS_API_ORDER.UPDATE.SUCCESS,
                error: {
                    render(res: Record<string, any>) {
                        const {data, status} = res.data.response;
                        if(switcherSpinner) switcherSpinner(false);
                        if (status === 500) {
                            return flagTransfer ? NAME_STATUS_API_ORDER.UPDATE.TRANSFER.ERROR_500 : NAME_STATUS_API_ORDER.UPDATE.ERROR_500;
                        }
                        if (data && status !== 500) {
                            showErrMessageUpdateOrder(data);
                        }
                        return flagTransfer ? NAME_STATUS_API_ORDER.UPDATE.TRANSFER.ERROR : NAME_STATUS_API_ORDER.UPDATE.ERROR;
                    }
                }
            }).then(() => {
            dispatch('orders/get');
            if(switcherSpinner) switcherSpinner(false);
            if(closeModal) closeModal();
            if(flagTransfer) dispatch('flagOrArray/clear');
            dispatch('statusTransferOrder/set', false);
        });

        return response
    };
    return {deleteOrder, closeOrder, createOrder, updateOrder};
};

export const orderRates = (data: tariffApiRes.IGetActualTariffRes): ITariffItem[] => {
    let arr: ITariffItem[] = [];
    objectKeys(data).forEach((key) => {
      if (data[key] !== null) {
          data[key]?.tariff_rates?.forEach((rate: TTariffRate) => {
            arr.push({
              ...rate,
              color_code: data[key]?.color_code
            })
          })
        }
    });
    return arr;
};

/// MULTI ORDERS

const defaultValue = {
    tariff: undefined,
    rate: undefined
};
export const findTariff = (
  tariffs:IGetActualTariffRes,
  typeOrder: ORDERS,
  customer: Record<string, any>,
  minutes_or_count: number,
  item: Record<string, any>,
  is_children: boolean
) => {
    try {
        const userType: string = customer[TYPE_USER_SPORTSMAN[typeOrder]].slug;
        if (userType) {
            if (tariffs[userType]) {
                const index = tariffs[userType].tariff_rates?.find((rate) =>
                  rate[typeOrder === ORDERS.PIPE ? 'minutes' : 'count_people'] === minutes_or_count &&
                  rate.is_child === is_children
                );
                if (!index) {
                    toast.error(`Ошибка добавления. На ${item.date} в ${item.time} нет актуального тарифа`);
                    toast.error(`Ошибка добавления. На ${item.date} в ${item.time} ставки нет`);
                    return defaultValue;
                }
                return {
                    tariff: tariffs[userType],
                    rate: index
                };
            }
        }

        toast.error(`Ошибка добавления. На ${item.date} в ${item.time} нет актуального тарифа`);
        toast.error(`Ошибка добавления. На ${item.date} в ${item.time} ставки нет`);

    } catch (e) {
        console.log(e);
    }
    return defaultValue;
};


/**
 * TODO оттипизировать values FormikValues updateOrders
 */
// Генерация заявок при мультисоздании
export const generateArrMultiOrders = (values: FormikValues, arrDate: IDateTimeOrdersState[], side: number, typeOrder: number):ICreateOrder[] => {
    const {is_automatic_stock, customer, participants, source, price_paid, session_minutes, comment, is_pay_here, is_arrived, is_children, tariff_rate, stock} = values;
    let arrOrder: ICreateOrder[] = [];
    arrDate.forEach((item) => {
        if (item.data.rate && item.data.tariff) {
            arrOrder.push({
              customer: {
                id: customer.value
              },
              source: source ? source.value : undefined,
              price_paid,
              comment,
              is_pay_here,
              is_arrived,
              is_children,
              side,
              is_automatic_stock,
              stock: stock || undefined,
              count_party: tariff_rate.count_people,
              fly_session_minutes: session_minutes === 0 ? undefined : customer[TYPE_USER_SPORTSMAN[typeOrder]].is_sport ? session_minutes : undefined,
              tariff: {
                id: item.data.tariff.id,
                title: item.data.tariff.title,
                is_child: item.data.tariff.is_child
              },
              tariff_rate: item.data.rate.id,
              price: String(Math.trunc(Number(item.data.rate.price))),
              start_at: dayjs(`${item.date} ${item.time}`, 'YYYY.MM.DD HH:mm').subtract(3, 'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
              participants: getArrParticipants(participants),
            });
        }
    });
    return arrOrder;
};

export const getTaskDateActiveFilters = (filters: IFilters) => {
    const isDateFilter = (key: string): boolean => {
        return key === 'created_at' || key === 'deadline_at' || key === 'start_at' || key === 'closed_at';
    };
    const res = Object.entries(filters);
    return res.filter(([key, value]) => isDateFilter(key) && value !== null);
};

export const createPayment = ({ data, name, typePayment, count }: ICreatePaymentHelper) => {
  const response = api.payment.createPayment(data)
  toast.promise(response, {
    pending: NAME_STATUS_API_ORDER.PAYMENT.PENDING,
    error: {
      render(res: Record<string, any>) {
        const { status, data } = res.data.response

        if (status === 500 || status === 501 || status === 502 || status === 503) {
          return ` ${name}${count ? ` (№${count})` : ''}. ${typePayment}. ${
            NAME_STATUS_API_ORDER.PAYMENT.ERROR_500 + status
          }`
        }

        if (Array.isArray(data)) {
          data.forEach((item: string) => {
            toast.error(item)
          })
        } else {
          Object.keys(data).forEach((key) => {
            toast.error(data[key][0])
          })
        }

        return `${name}${count ? ` (№${count})` : ''}. ${typePayment}.  ${
          NAME_STATUS_API_ORDER.PAYMENT.ERROR
        } `
      }
    }
  })
  return response
}
export const createPaymentDeposit = (data: orderApiReq.IPostCreateDepositReq, name: string, formik?: any, setIsBill?: (e:Record<string, any>) => void) => {
    const response = api.order.createDeposit(data);
    toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.PAYMENT.PENDING,
            success: ` ${name}. ${setIsBill ? NAME_STATUS_API_ORDER.PAYMENT.SUCCESS_URL : NAME_STATUS_API_ORDER.PAYMENT.SUCCESS}`,
            error: {
                render(res: Record<string, any>) {
                    const {status, data} = res.data.response;


                    switch (status) {
                      case 500:
                      case 501:
                      case 502:
                      case 503:
                        return ` ${name}. ${NAME_STATUS_API_ORDER.PAYMENT.ERROR_500 + status}`;
                      default:
                        break;
                    }

                    if (Array.isArray(data)) {
                        data.forEach((item: string) => {
                            toast.error(item);
                        });
                    } else {
                        Object.keys(data).forEach((key) => {
                            toast.error(data[key]);
                        });
                    }

                    return `${name}.  ${setIsBill ? NAME_STATUS_API_ORDER.PAYMENT.ERROR_URL : NAME_STATUS_API_ORDER.PAYMENT.ERROR} `;
                }
            }
        }).then((res: any) => {
        if(formik) formik.setFieldValue('payment_url',res.pay_link)
        if(setIsBill) setIsBill({flag: true, link: res.pay_link});
    });
    return response;
};

export const createPaymentServices = (data: orderApiReq.ICreateServicesReq, name: string, formik?: any, setIsBill?: (e:Record<string, any>) => void,) => {
  const response = api.order.createServices(data);
  toast.promise(
      response,
      {
          pending: NAME_STATUS_API_ORDER.PAYMENT.PENDING,
          success: ` ${name}. ${setIsBill ? NAME_STATUS_API_ORDER.PAYMENT.SUCCESS_URL : NAME_STATUS_API_ORDER.PAYMENT.SUCCESS}`,
          error: {
              render(res: Record<string, any>) {
                  const {status, data} = res.data.response;

                  switch (status) {
                    case 500:
                    case 501:
                    case 502:
                    case 503:
                      return ` ${name}. ${NAME_STATUS_API_ORDER.PAYMENT.ERROR_500 + status}`;
                    default:
                      break;
                  }
                  if (Array.isArray(data)) {
                      data.forEach((item: string) => {
                          toast.error(item);
                      });
                  } else {
                      Object.keys(data).forEach((key) => {
                          toast.error(data[key]);
                      });
                  }

                  return `${name}.  ${setIsBill ? NAME_STATUS_API_ORDER.PAYMENT.ERROR_URL : NAME_STATUS_API_ORDER.PAYMENT.ERROR} `;
              }
          }
      }).then((res: any) => {
      if(formik) formik.setFieldValue('payment_url',res.pay_link)
      if(setIsBill) setIsBill({flag: true, link: res.pay_link});
  });
  return response;
};

export const createPaymentCertificate = (data: orderApiReq.IPostCreateCertificateReq, name: string, setIsBill?: (e:Record<string, any>) => void,) => {
    const response = api.order.createCertificates(data);
    toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.PAYMENT.PENDING,
            success: ` ${name}. ${setIsBill ? NAME_STATUS_API_ORDER.PAYMENT.SUCCESS_URL : NAME_STATUS_API_ORDER.PAYMENT.SUCCESS}`,
            error: {
                render(res: Record<string, any>) {
                    const {status, data} = res.data.response;
                    switch (status) {
                      case 500:
                      case 501:
                      case 502:
                      case 503:
                        return ` ${name}. ${NAME_STATUS_API_ORDER.PAYMENT.ERROR_500 + status}`;
                      default:
                        break;
                     }
                   
                    if (Array.isArray(data)) {
                        data.forEach((item: string) => {
                            toast.error(item);
                        });
                    } else {
                        Object.keys(data).forEach((key) => {
                            toast.error(data[key][0]);
                        });
                    }

                    return `${name}.  ${setIsBill ? NAME_STATUS_API_ORDER.PAYMENT.ERROR_URL : NAME_STATUS_API_ORDER.PAYMENT.ERROR} `;
                }
            }
        }).then((res: any) => {
        // if(formik) formik.setFieldValue('payment_url',res.pay_link)
        if(setIsBill) setIsBill({flag: true, link: res.payment_url});
    });
    return response;
};

export const getStringValues = (arr: any) => {
    return arr.map((item: any) => item.value).join(',');
};

export const getSelectValues = (arr: any, value: any) => {
    let newArr: any = [];
    // const arrValue = value.split(',');
    value.forEach((item: string) => {
        newArr.push(arr[Number(item)]);
    });
    return newArr;
};

export const userTypeFormater = (data: any, icon: string | null = null) => {
    return data.map(({title_ru, slug, id}: any) => {
        return {
            id,
            label: title_ru,
            value: slug,
            icon
        };
    });
};
export const getCheckedItem = (arr: ITaskState[]) => {
    return arr.filter((item) => {
        return !!item.checked;
    });
};

export const getGroupValues = (arr: TLabelAndValue[]) => {
  return arr.map((item) => item.value)
}

export const counterPriceMultiOrders = (pay_order: Record<string, any>) => {
    let price = Number(pay_order.amount);
    let price_paid_money = Number(pay_order.price_paid);
    let price_paid_resource = 0 ;
    let minutes = 0;
    let count_people = 0;
    pay_order.orders.forEach((order: Record<string, any>) => {
        minutes += Number(order.tariff_rate.minutes);
        count_people += Number(order.tariff_rate.count_people);
        price_paid_resource +=
            Number(order.certificate_mins_paid)
            +
            Number(order.certificate_sets_paid)
            +
            Number(order.deposit_mins_paid)
            +
            Number(order.deposit_sets_paid)
    });

    return {
        price,
        price_paid_money,
        total_money: price - price_paid_money,
        price_paid_resource,
        minutes,
        count_people
    };
};

export const getInfoScore = (order: Record<string, any>) => {
    const response = api.order.getOrder(order[0]?.id);
    toast.promise(
        response,
        {
            pending: 'Идет процесс получения информации о счете..',
            // success: 'Счет успешно получен!',
            error: {
                render(res: Record<string, any>) {
                    const {data, status} = res.data.response;
                    if (status === 500) {
                        toast.error(NAME_STATUS_API_ORDER.CREATE.ORDERS.ERROR_500);
                    }
                    if (data && status !== 500) {
                        showErrMessage(data);
                    }
                    toast.error(NAME_STATUS_API_ORDER.CREATE.ORDERS.ERROR);
                }
            }
        });
    return response;
};

export const showToastTaskChanged = (toastInfo: Record<string, any>, user: Record<string, any>) => {
    try {
        const {logics, title, is_urgent,notification_type} = toastInfo.message;
        const findGroupUser = () => {
            let flag = false;
            user.groups.forEach((n: Record<string, any>) => {
                if (logics.groups_id.includes(n.id)) flag = true;
            });
            return flag;
        };

        if (logics.user_id === user.id || findGroupUser()) {
            if (is_urgent || notification_type === NOTIFICATION_TYPE.TASK_REMINDER) {
                toast.warn(`Задача! ${title}`, {
                    position: 'bottom-right',
                    className: cn({
                        'task-urgent': is_urgent  || notification_type === NOTIFICATION_TYPE.TASK_REMINDER
                    }),
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    autoClose: false,
                    draggable: false,
                });
            } else {
                toast.info(`Задача! ${title}`, {
                    className: cn({
                        'task-load': !is_urgent
                    }),
                    position: 'bottom-right',
                    autoClose: 15000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            }

        }
    } catch (e) {
        console.log(e);
    }
};



export const definePayLinkTtl = (activeItem: Record<string, any>) => {
  const duration_check: string = activeItem.duration_check || activeItem.online_pay_link_ttl
  if (duration_check && duration_check !== PAY_LINK_TTL_EMPTY) {
    return duration_check
  } 
     return PAY_LINK_TTL
}

export const convertTimeToIntegerMinutes = (data: string) => {
    let count = 0;

    count = Number(dayjs(data, 'HH:mm:ss').format('HH')) * 60;
    count += Number(dayjs(data, 'HH:mm:ss').format('mm'));

    return count;
};

export const createPayOrderOnline = (data: orderApiReq.ICreatePayOrderOnlineReq[], setIsBill: (e:boolean) => void, formik: FormikValues) => {
    const response = api.order.createPayOrderOnline(data);
     toast.promise(
        response,
        {
            pending: {
                render() {
                    return NAME_STATUS_API_ORDER.PAYMENT_ONLINE.PENDING
                }
            },
            error: {
                render(res: Record<string, any>) {
                    const {status, data} = res.data.response;
                    if (status === 500 || status === 501 || status === 502 || status === 503) {
                        toast.error(NAME_STATUS_API_ORDER.PAYMENT_ONLINE.ERROR_500 + status);
                    }
                    if (data) {
                        // eslint-disable-next-line guard-for-in,no-restricted-syntax
                        for (let key in data) {
                            if (Array.isArray(data[key])) {
                                toast.error(data[key][0]);
                            }
                        }
                    }
                    return NAME_STATUS_API_ORDER.PAYMENT_ONLINE.ERROR;
                }
            }
        }).then((res) => {
         formik.setFieldValue('payment_url', res.link)
        setIsBill(true);
    })
     return response;
};

const countSetDeposit = (data: TUserDeposit[]) =>{
    const countRent = data.filter((elem) => !!elem.rent_pay_count).reduce(
        (previousValue: any, currentValue: any) => previousValue + Math.trunc(currentValue.rent_pay_count),
        0)
    const countSet = data
                .filter((item)=> item.expiry_at === null ? true : dayjs(item.expiry_at).isSameOrAfter(dayjs()))
                .reduce(
                (previousValue, currentValue) => previousValue + Math.trunc(currentValue.sets),
                0
            )
    return `${countSet} сет. и ${countRent} ар.`
}

const countMinDeposit = (data: TUserDeposit[]) => { 
    const count = data.filter((item)=> item.expiry_at === null ? true : dayjs(item.expiry_at).isSameOrAfter(dayjs()))
    .reduce(
    (previousValue, currentValue) => previousValue + Math.trunc(currentValue.minutes),
    0
)

return `${count} мин.`
}

export const DEPOSITS_INFO = (data: IUserDepositList) => {
  
  return [
    {
      id: TYPES_DEPOSITS.PIPE,
      title: DEPOSIT_PAYMENT_TITLE.RESOURCE,
      count_price: countMinDeposit(data[ARR_TYPE[TYPES_DEPOSITS.PIPE] as keyof typeof ARR_TYPE] as TUserDeposit[])
    },
    {
      id: TYPES_DEPOSITS.WAVE,
      title: DEPOSIT_PAYMENT_TITLE.RESOURCE,
      count_price: countSetDeposit(data[ARR_TYPE[TYPES_DEPOSITS.WAVE] as keyof typeof ARR_TYPE] as TUserDeposit[])
    }
  ]
}

export const initialValueUserModal = (userData?: Record<string, any>) => {
    const initialValues: IInitialValues = {
        user: {
            email: (userData && userData.email) ? userData.email : '',
            first_name: (userData && userData.first_name) ? userData?.first_name : '',
            last_name: (userData && userData.last_name) ? userData?.last_name : '',
            patronymic_name: (userData && userData.patronymic_name) ? userData?.patronymic_name : '',
            username: (userData && userData.username) ? userData?.username : '',
            user_type: (userData && userData.type_user) ? userData?.type_user : '',
            phone: (userData && userData.phone) ? `+${userData?.phone}` : '',
            sex: (userData && userData.sex) ? userData?.sex : undefined,
            birthday: (userData && userData.birthday) ? dayjs(userData?.birthday).format('DD-MM-YYYY') : undefined,
            source_of_traffic: (userData && userData.source_of_traffic) ? userData?.source_of_traffic : '',
            is_news_email: (userData && typeof userData.is_news_email === 'boolean') ? userData?.is_news_email : true,
            comment: (userData && userData.comment) ? userData?.comment : '',
            tube_user_type: (userData && userData.tube_user_type) ? {
                id: userData?.tube_user_type.id,
                label: userData?.tube_user_type.title_ru,
                value: userData?.tube_user_type.slug,
                icon: TubeIcon
            } : {label: 'Новичок', value: 'regular', icon: TubeIcon},
            wave_user_type: (userData && userData.wave_user_type) ? {
                id: userData?.wave_user_type.id,
                label: userData?.wave_user_type.title_ru,
                value: userData?.wave_user_type.slug,
                icon: WaveIcon
            } : {label: 'Новичок', value: 'regular', icon: WaveIcon},
            acceptance_date_for_airtube: (userData && userData.acceptance_date_for_airtube) ? dayjs(userData?.acceptance_date_for_airtube).format('DD-MM-YYYY') : undefined,
            acceptance_date_for_wave: (userData && userData.acceptance_date_for_wave) ? dayjs(userData?.acceptance_date_for_wave).format('DD-MM-YYYY') : undefined,
        },
        address: {
            country: (userData && userData.country) ? userData?.country : '',
            region: (userData && userData.region) ? userData?.region : '',
            district: (userData && userData.district) ? userData?.district : '',
            city: (userData && userData.city) ? userData?.city : '',
            street: (userData && userData.street) ? userData?.street : '',
            zip_code: (userData && userData.zip_code) ? userData?.zip_code : '',
            house: (userData && userData.house) ? userData?.house : '',
            building: (userData && userData.building) ? userData?.building : '',
            apartment: (userData && userData.apartment) ? userData?.apartment : ''
        },
        documents: {
            document_type: 0,
            document_number: (userData && userData.document_number) ? userData?.document_number : '',
            document_granted_by: (userData && userData.document_granted_by) ? userData?.document_granted_by : '',
            document_serial: (userData && userData.document_serial) ? userData?.document_serial : '',
            document_granted: (userData && userData.document_granted) ? userData?.document_granted : '',
            document_department_code: (userData && userData.document_department_code) ? userData?.document_department_code : ''
        }
    };
    return initialValues;
};

export const createResponseUser = ({id, type, data}: ICreateResponseUser) => {
    let response: any;
    switch (type) {
      case CREATE_USER_RES_TYPE.EMAIL:
        response = api.user.responseUserEmail(id, { ...data })
        break
      case CREATE_USER_RES_TYPE.SMS:
        response = api.user.responseUserSms(id, { ...data })
        break
      default:
        response = api.user.responseUserEmail(id, { ...data })
    }

    toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.RESPONSE_TASK.PENDING,
            error: {
                render(res: Record<string, any>) {
                    const {status, data} = res.data.response;
                    if (status === 500 || status === 501 || status === 502 || status === 503) {
                        toast.error(NAME_STATUS_API_ORDER.RESPONSE_TASK.ERROR_500 + status);
                    }
                    if (data) {
                        // eslint-disable-next-line guard-for-in,no-restricted-syntax
                        for (let key in data) {
                            toast.error(data[key][0]);
                        }
                    }
                    return NAME_STATUS_API_ORDER.RESPONSE_TASK.ERROR;
                }
            }
        });
    return response;
};

export const countPriceMulti = (arr:IDateTimeOrdersState[]) => {
    const initialValue = 0
    return arr.reduce(
        (previousValue, currentValue) => previousValue + Math.trunc(Number(currentValue.data.rate.price)),
        initialValue
    )
}


export const returnDeposit = (data: TReturnDeposit) => {
    const response = api.payment.returnDeposit(data);
    toast.promise(
        response,
        {
            pending: {
                render() {
                    return NAME_STATUS_API_ORDER.RETURN.PENDING
                }
            },
            error: {
                render(res: Record<string, any>) {
                    const {status, data} = res.data.response;
                    if (status === 500 || status === 501 || status === 502 || status === 503) {
                        toast.error(NAME_STATUS_API_ORDER.RETURN.ERROR_500 + status);
                    }
                    if (data) {
                        // eslint-disable-next-line guard-for-in,no-restricted-syntax
                        for (let key in data) {
                            if (Array.isArray(data[key])) {
                                toast.error(data[key][0]);
                            }
                        }
                    }
                    return NAME_STATUS_API_ORDER.RETURN.ERROR;
                }
            }
        })
    return response;
};

export const returnCertificate = (data: TReturnCertificate) => {
    const response = api.payment.returnCertificate(data);
    toast.promise(
      response,
      {
          pending: {
              render() {
                  return NAME_STATUS_API_ORDER.RETURN.PENDING
              }
          },
          error: {
              render(res: Record<string, any>) {
                  const {status, data} = res.data.response;
                  if (status === 500 || status === 501 || status === 502 || status === 503) {
                      toast.error(NAME_STATUS_API_ORDER.RETURN.ERROR_500 + status);
                  }
                  if (data) {
                      // eslint-disable-next-line guard-for-in,no-restricted-syntax
                      for (let key in data) {
                          if (Array.isArray(data[key])) {
                              toast.error(data[key][0]);
                          }
                      }
                  }
                  return NAME_STATUS_API_ORDER.RETURN.ERROR;
              }
          }
      })
    return response;
};

export const returnMoneyDeposit = (data: TReturnMoneyDeposit) => {
    const response = api.payment.returnMoneyDeposit(data);
    toast.promise(
      response,
      {
          pending: {
              render() {
                  return NAME_STATUS_API_ORDER.RETURN.PENDING
              }
          },

          error: {
              render(res: Record<string, any>) {
                  const {status, data} = res.data.response;
                  if (status === 500 || status === 501 || status === 502 || status === 503) {
                      toast.error(NAME_STATUS_API_ORDER.RETURN.ERROR_500 + status);
                  }
                  if (data) {
                      // eslint-disable-next-line guard-for-in,no-restricted-syntax
                      for (let key in data) {
                          if (Array.isArray(data[key])) {
                              toast.error(data[key][0]);
                          }
                      }
                  }
                  return NAME_STATUS_API_ORDER.RETURN.ERROR;
              }
          }
      })
    return response;
};

export const handleOnPressKey =(e:React.KeyboardEvent<HTMLElement>)=>{
  if (!new RegExp(/\d/).test(e.key)) {
    e.preventDefault();
  }  
}


export const getLoadUserOptions = async ({search, typeOrder, params}: {search: string, typeOrder?:ORDERS, params?:userApiReq.IGetUsersReq}) => {
    
  const userKey = ORDERS.PIPE === typeOrder ? 'acceptance_date_for_airtube' : 'acceptance_date_for_wave'

  const hasSearchValue = search !== '' ? search : undefined;
  const { results, next } = await api.user.getUsers({...params, search: hasSearchValue });
  const filteredOptions = results.map((el) => {
    return {
      value: el.id,
      label: `${el.last_name || ''} ${el.first_name || ''} ${el.phone || ''}`,
      color: el[userKey  as keyof IUser] !== null ? 'green' : 'red',
      ...el
    }
  })

return {
  options: filteredOptions,
  hasMore: Boolean(next),
};
}